'use strict';

var react = require('react');
var useEventListener = require('./useEventListener-DSwo06ND.js');

/** Prefer using the onKeyDown listener on elements whenever possible to avoid
 * race condition issues between native and synthetic Esc keydown events.
 */
const useOnEscape = (handler, options = {}) => {
    const { active = true } = options;
    const [ref, setRef] = react.useState(null);
    useEventListener.useEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || active === false) {
            return;
        }
        handler();
        event.preventDefault();
        event.stopPropagation();
    }, options.element ?? ref);
    return setRef;
};

exports.useOnEscape = useOnEscape;
//# sourceMappingURL=useOnEscape-vb8gPtDo.js.map
